export const VIDEO_ROUTES = [
    // {
    //   path: "basicMap",
    //   name: "basicMap",
    //   component: BasicMap
    // }
];